const createQuestion = (
    difficulty,
    question,
    answer,
    distractors,
    explanation
) => ({
    difficulty,
    question,
    choices: [answer, ...distractors],
    answer,
    explanation,
});

const createMovie = ({
                         title,
                         year,
                         accent,
                         posterEmoji,
                         questions,
                     }) => ({
    title,
    year,
    accent,
    posterEmoji,
    questions: questions.map(
        ([difficulty, question, answer, distractors, explanation]) =>
            createQuestion(
                difficulty,
                question,
                answer,
                distractors,
                explanation
            )
    ),
});

export const demoMovies = {
    darkKnight: createMovie({
        title: 'The Dark Knight',
        year: '2008',
        accent: '#f59e0b',
        posterEmoji: '🃏',
        questions: [
            [
                'easy',
                "What color was the Joker's nurse uniform?",
                'White',
                ['Blue', 'Pink', 'Green'],
                'The Joker disguises himself in a white nurse uniform at Gotham General.',
            ],
            [
                'easy',
                "What is Harvey Dent's nickname before his fall?",
                'The White Knight',
                ['Two-Face', 'The D.A.', 'Gotham Hammer'],
                'Gotham considers Harvey Dent its White Knight.',
            ],
            [
                'easy',
                'Who plays Batman?',
                'Christian Bale',
                ['Ben Affleck', 'Robert Pattinson', 'Michael Keaton'],
                'Christian Bale plays Bruce Wayne and Batman.',
            ],
            [
                'easy',
                'Which city does Batman protect?',
                'Gotham',
                ['Metropolis', 'Blüdhaven', 'Central City'],
                'Batman protects Gotham City.',
            ],
            [
                'easy',
                'What type of vehicle does Batman use after the Tumbler is destroyed?',
                'Batpod',
                ['Batcycle', 'Night Rider', 'Gotham Speeder'],
                'Batman escapes from the Tumbler using the Batpod.',
            ],
            [
                'medium',
                'What object does the Joker use as his calling card?',
                'A playing card',
                ['A coin', 'A rose', 'A chess piece'],
                'The Joker leaves Joker playing cards at crime scenes.',
            ],
            [
                'medium',
                'Who says, “You either die a hero, or you live long enough to see yourself become the villain”?',
                'Harvey Dent',
                ['Bruce Wayne', 'Jim Gordon', 'Alfred'],
                'Harvey says the line while dining with Bruce and Rachel.',
            ],
            [
                'medium',
                'What does Batman turn into a citywide sonar system?',
                'Every phone in Gotham',
                ['Police radios', 'Subway cameras', 'Traffic lights'],
                'Batman uses Gotham’s phones to create a sonar map.',
            ],
            [
                'medium',
                'What is the Joker trying to prove with the two ferries?',
                'Anyone can be corrupted',
                [
                    'Batman is wealthy',
                    'Harvey is innocent',
                    'Gotham should be abandoned',
                ],
                'The ferry dilemma is the Joker’s moral experiment.',
            ],
            [
                'medium',
                'Who captures Lau in Hong Kong?',
                'Batman',
                ['Jim Gordon', 'Harvey Dent', 'Rachel Dawes'],
                'Batman extracts Lau from Hong Kong and returns him to Gotham.',
            ],
            [
                'medium',
                'Who is promoted to police commissioner?',
                'Jim Gordon',
                ['Harvey Bullock', 'Anna Ramirez', 'Gillian Loeb'],
                'Jim Gordon becomes commissioner after Loeb is killed.',
            ],
            [
                'hard',
                'What phrase is painted on the Joker’s fire truck?',
                'S laughter is the best medicine',
                [
                    'Why So Serious?',
                    'I Believe in Harvey Dent',
                    'Put on a Happy Face',
                ],
                'The spacing transforms “slaughter” into “S laughter.”',
            ],
            [
                'hard',
                'Which building is used for the hostage trap near the finale?',
                'Prewitt Building',
                ['Wayne Tower', 'Gotham Central', 'Maroni Club'],
                'Batman enters the Prewitt Building during the SWAT operation.',
            ],
            [
                'hard',
                'What does Lucius Fox say he will do if the sonar machine remains at Wayne Enterprises?',
                'Resign',
                ['Call Gordon', 'Expose Batman', 'Destroy it himself'],
                'Lucius agrees to help once but refuses to work there if the system remains.',
            ],
            [
                'easy',
                'What kind of coin does Harvey Dent carry?',
                'A two-headed coin',
                ['A gold dollar', 'A quarter', 'A subway token'],
                'Harvey initially relies on a two-headed coin that guarantees his preferred outcome.',
            ],
        ],
    }),

    interstellar: createMovie({
        title: 'Interstellar',
        year: '2014',
        accent: '#60a5fa',
        posterEmoji: '🚀',
        questions: [
            [
                'easy',
                'Who directed Interstellar?',
                'Christopher Nolan',
                ['Denis Villeneuve', 'James Cameron', 'Ridley Scott'],
                'Christopher Nolan directed the space epic.',
            ],
            [
                'easy',
                'What crop does Cooper farm near the beginning?',
                'Corn',
                ['Wheat', 'Soybeans', 'Potatoes'],
                'Cooper farms corn in a dust-stricken future.',
            ],
            [
                'easy',
                "What is Cooper's daughter's name?",
                'Murph',
                ['Brand', 'Case', 'Mann'],
                'Murph is Cooper’s daughter and the emotional center of the story.',
            ],
            [
                'easy',
                'What is the name of the sarcastic robot?',
                'TARS',
                ['CASE', 'KIPP', 'HAL'],
                'TARS accompanies Cooper on the mission.',
            ],
            [
                'medium',
                "What is Murph's profession as an adult?",
                'NASA scientist',
                ['Pilot', 'Teacher', 'Doctor'],
                'Adult Murph works on the gravity equation at NASA.',
            ],
            [
                'medium',
                'What is the name of the black hole?',
                'Gargantua',
                ['Leviathan', 'Event Horizon', 'Prometheus'],
                'The Endurance mission travels through the Gargantua system.',
            ],
            [
                'medium',
                "Why is time dramatically slower on Miller's planet?",
                'It is close to Gargantua',
                [
                    'The planet rotates backward',
                    'Its atmosphere freezes time',
                    'NASA designed it that way',
                ],
                'The planet’s proximity to the black hole causes extreme time dilation.',
            ],
            [
                'medium',
                "Approximately how much Earth time passes during the visit to Miller's planet?",
                '23 years',
                ['Seven years', '50 years', '12 years'],
                'Romilly waits more than 23 years aboard the Endurance.',
            ],
            [
                'medium',
                'What object does Cooper use to communicate with Murph from the tesseract?',
                'Her watch',
                ['Her telescope', 'A radio', 'A compass'],
                'Cooper manipulates the watch’s second hand using gravity.',
            ],
            [
                'hard',
                'Who remains aboard the Endurance during the trip to Miller’s planet?',
                'Romilly',
                ['Doyle', 'Brand', 'Mann'],
                'Romilly waits aboard the ship while decades pass for him.',
            ],
            [
                'hard',
                'Which scientist falsified the data from his planet?',
                'Dr. Mann',
                ['Dr. Brand', 'Romilly', 'Cooper'],
                'Dr. Mann sends false data because he wants to be rescued.',
            ],
            [
                'hard',
                'What information does Cooper transmit through Murph’s watch?',
                'Quantum data',
                ['Launch coordinates', 'A distress signal', 'A map to Edmunds'],
                'The quantum data allows Murph to complete the gravity equation.',
            ],
        ],
    }),

    spiderManNoWayHome: createMovie({
        title: 'Spider-Man: No Way Home',
        year: '2021',
        accent: '#ef4444',
        posterEmoji: '🕷️',
        questions: [
            [
                'easy',
                'Why does Peter visit Doctor Strange?',
                'To make people forget his identity',
                [
                    'To travel through time',
                    'To find Tony Stark',
                    'To recover his suit',
                ],
                'Peter asks Strange to make everyone forget that he is Spider-Man.',
            ],
            [
                'easy',
                'Who is Peter Parker’s best friend?',
                'Ned Leeds',
                ['Flash Thompson', 'Harry Osborn', 'Happy Hogan'],
                'Ned is Peter’s closest friend.',
            ],
            [
                'easy',
                'Which villain says, “Hello, Peter”?',
                'Doctor Octopus',
                ['Electro', 'Green Goblin', 'Sandman'],
                'Doctor Octopus greets Peter after appearing on the bridge.',
            ],
            [
                'easy',
                'How many Spider-Men eventually fight together?',
                'Three',
                ['Two', 'Four', 'Five'],
                'Three live-action versions of Spider-Man unite.',
            ],
            [
                'medium',
                'Where does the final battle take place?',
                'The Statue of Liberty',
                ['Avengers Tower', 'Times Square', 'Brooklyn Bridge'],
                'The final battle takes place around the renovated Statue of Liberty.',
            ],
            [
                'medium',
                'Who helps Peter develop cures for the villains?',
                'The other Spider-Men',
                ['Nick Fury', 'Happy Hogan', 'Wong'],
                'The three Spider-Men work together in the school laboratory.',
            ],
            [
                'medium',
                'Which Spider-Man catches MJ after she falls?',
                "Andrew Garfield's Spider-Man",
                [
                    "Tom Holland's Spider-Man",
                    "Tobey Maguire's Spider-Man",
                    'Doctor Strange',
                ],
                'Andrew’s Spider-Man catches MJ, echoing his loss of Gwen Stacy.',
            ],
            [
                'medium',
                'Which villain is powered by electricity?',
                'Electro',
                ['Lizard', 'Sandman', 'Green Goblin'],
                'Electro absorbs electricity and gains an upgraded form.',
            ],
            [
                'medium',
                'Where are the captured villains initially held?',
                "Doctor Strange's undercroft",
                ['The Raft', 'Avengers Tower', 'A police station'],
                'Strange holds the villains in magical cells beneath the Sanctum.',
            ],
            [
                'hard',
                'What does Peter ultimately ask Doctor Strange to do?',
                'Make everyone forget Peter Parker',
                [
                    'Erase every villain',
                    'Destroy the multiverse',
                    'Make everyone forget MJ',
                ],
                'Peter sacrifices his relationships so the multiverse can stabilize.',
            ],
            [
                'hard',
                'Which villain is cured by repairing his inhibitor chip?',
                'Doctor Octopus',
                ['Electro', 'Sandman', 'Lizard'],
                'Peter repairs the chip that allows Otto to control his mechanical arms.',
            ],
            [
                'hard',
                'What does Peter make for himself at the end?',
                'A new Spider-Man suit',
                [
                    'A new web shooter for Ned',
                    'A portal device',
                    'A Doctor Strange cape',
                ],
                'Peter sews a new red-and-blue suit as he begins his independent life.',
            ],
        ],
    }),

    wednesday: createMovie({
        title: 'Wednesday',
        year: '2022',
        accent: '#a78bfa',
        posterEmoji: '🖤',
        questions: [
            [
                'easy',
                'What school does Wednesday attend?',
                'Nevermore Academy',
                ['Hogwarts', 'Jericho Prep', 'Ravenwood'],
                'Wednesday enrolls at Nevermore Academy.',
            ],
            [
                'easy',
                'What is the name of the disembodied hand?',
                'Thing',
                ['Fester', 'Lurch', 'Handy'],
                'Thing spies on and assists Wednesday.',
            ],
            [
                'easy',
                'What instrument does Wednesday play?',
                'Cello',
                ['Violin', 'Piano', 'Harp'],
                'Wednesday is frequently shown playing the cello.',
            ],
            [
                'easy',
                "What is Wednesday's roommate's name?",
                'Enid Sinclair',
                ['Bianca Barclay', 'Yoko Tanaka', 'Marilyn Thornhill'],
                'Enid is Wednesday’s colorful werewolf roommate.',
            ],
            [
                'medium',
                'What town is located near Nevermore?',
                'Jericho',
                ['Salem', 'Greendale', 'Ravenswood'],
                'Jericho is the neighboring town.',
            ],
            [
                'medium',
                'What special ability does Wednesday experience?',
                'Psychic visions',
                ['Teleportation', 'Mind control', 'Invisibility'],
                'Physical contact can trigger Wednesday’s visions.',
            ],
            [
                'medium',
                'What extracurricular activity does Wednesday join?',
                'Fencing',
                ['Cheerleading', 'Basketball', 'Archery'],
                'Wednesday challenges Bianca during fencing practice.',
            ],
            [
                'medium',
                'Who is Nevermore’s principal?',
                'Larissa Weems',
                ['Marilyn Thornhill', 'Valerie Kinbott', 'Morticia Addams'],
                'Larissa Weems is Nevermore Academy’s principal.',
            ],
            [
                'hard',
                'What creature is responsible for the attacks around Jericho?',
                'A Hyde',
                ['A banshee', 'A vampire', 'A siren'],
                'The monster is revealed to be a Hyde.',
            ],
            [
                'hard',
                'Who controls the Hyde?',
                'Marilyn Thornhill',
                ['Bianca Barclay', 'Sheriff Galpin', 'Principal Weems'],
                'Thornhill manipulates and controls the Hyde.',
            ],
        ],
    }),

    breakingBad: createMovie({
        title: 'Breaking Bad',
        year: '2008',
        accent: '#22c55e',
        posterEmoji: '🧪',
        questions: [
            [
                'easy',
                'What subject does Walter White teach?',
                'Chemistry',
                ['Physics', 'Biology', 'Mathematics'],
                'Walter is a high-school chemistry teacher.',
            ],
            [
                'easy',
                "Who is Walter's former student and partner?",
                'Jesse Pinkman',
                ['Gus Fring', 'Todd Alquist', 'Hank Schrader'],
                'Jesse becomes Walter’s partner.',
            ],
            [
                'easy',
                'What color is Walt and Jesse’s signature product?',
                'Blue',
                ['Pink', 'Green', 'Purple'],
                'Their unusually pure methamphetamine is blue.',
            ],
            [
                'easy',
                'What criminal alias does Walter adopt?',
                'Heisenberg',
                ['Oppenheimer', 'Eisenhart', 'Haber'],
                'Heisenberg becomes Walter’s criminal identity.',
            ],
            [
                'easy',
                "Who is Walter's DEA agent brother-in-law?",
                'Hank Schrader',
                ['Saul Goodman', 'Mike Ehrmantraut', 'Gale Boetticher'],
                'Hank works for the Drug Enforcement Administration.',
            ],
            [
                'medium',
                'Which lawyer represents Walt and Jesse?',
                'Saul Goodman',
                ['Howard Hamlin', 'Kim Wexler', 'Cliff Main'],
                'Saul becomes their attorney and criminal fixer.',
            ],
            [
                'medium',
                'What fast-food chain does Gus Fring operate?',
                'Los Pollos Hermanos',
                ['Pollos Locos', 'Chicken King', 'Pollos Blancos'],
                'Gus uses Los Pollos Hermanos as part of his legitimate cover.',
            ],
            [
                'medium',
                'What type of vehicle is used as the first mobile lab?',
                'An RV',
                ['A school bus', 'A delivery van', 'A train car'],
                'Walt and Jesse initially cook inside an RV.',
            ],
            [
                'medium',
                'What is the name of Walter’s car wash?',
                'A1A Car Wash',
                ['Crystal Clean', 'Bogdan’s Auto Spa', 'Blue Sky Wash'],
                'Walter and Skyler purchase the A1A Car Wash.',
            ],
            [
                'hard',
                'What plant is used to poison Brock?',
                'Lily of the valley',
                ['Ricín plant', 'Oleander', 'Nightshade'],
                'Walter uses lily of the valley to manipulate Jesse.',
            ],
            [
                'hard',
                'What book helps Hank connect Walt to Gale?',
                'Leaves of Grass',
                ['The Raven', 'Ozymandias', 'Walden'],
                'Gale’s inscription in Walt’s copy helps Hank identify Heisenberg.',
            ],
            [
                'hard',
                'What machine gun does Walter mount in the trunk of his car?',
                'M60',
                ['M16', 'AK-47', 'MP5'],
                'Walter rigs an M60 to fire remotely during the finale.',
            ],
        ],
    }),

    strangerThings: createMovie({
        title: 'Stranger Things',
        year: '2016',
        accent: '#dc2626',
        posterEmoji: '🚲',
        questions: [
            [
                'easy',
                "What frozen waffle brand is Eleven's favorite?",
                'Eggo',
                ['Kodiak', 'Leggo', 'Toaster Treats'],
                'Eleven loves Eggo waffles.',
            ],
            [
                'easy',
                'What town is the show set in?',
                'Hawkins',
                ['Derry', 'Sunnydale', 'Arcadia'],
                'The story begins in Hawkins, Indiana.',
            ],
            [
                'easy',
                'Who disappears at the beginning of Season 1?',
                'Will Byers',
                ['Mike Wheeler', 'Lucas Sinclair', 'Steve Harrington'],
                'Will’s disappearance launches the central mystery.',
            ],
            [
                'easy',
                'What is the police chief’s name?',
                'Jim Hopper',
                ['Bob Newby', 'Ted Wheeler', 'Sam Owens'],
                'Jim Hopper is the Hawkins police chief.',
            ],
            [
                'medium',
                'What game are the kids playing in the first episode?',
                'Dungeons & Dragons',
                ['Risk', 'Monopoly', 'Magic: The Gathering'],
                'Their D&D campaign foreshadows the coming threat.',
            ],
            [
                'medium',
                'What is the alternate dimension called?',
                'The Upside Down',
                ['The Dark Place', 'The Other Side', 'The Void'],
                'The Upside Down is a decaying mirror of Hawkins.',
            ],
            [
                'medium',
                'What song helps Max resist Vecna?',
                'Running Up That Hill',
                ['Heroes', 'Africa', 'Should I Stay or Should I Go'],
                'Kate Bush’s song becomes Max’s emotional lifeline.',
            ],
            [
                'medium',
                'Where does Steve work with Robin during Season 3?',
                'Scoops Ahoy',
                ['Family Video', 'Benny’s Burgers', 'Surfer Boy Pizza'],
                'Steve and Robin work at Scoops Ahoy in Starcourt Mall.',
            ],
            [
                'hard',
                "What number is tattooed on Eleven's wrist?",
                '011',
                ['001', '008', '111'],
                'Eleven is identified as Experiment 011.',
            ],
            [
                'hard',
                'What is Vecna’s human name?',
                'Henry Creel',
                ['Billy Hargrove', 'Victor Creel', 'Martin Brenner'],
                'Vecna was once Henry Creel, also known as One.',
            ],
        ],
    }),

    toyStory: createMovie({
        title: 'Toy Story',
        year: '1995',
        accent: '#f59e0b',
        posterEmoji: '🤠',
        questions: [
            [
                'easy',
                "Who is Andy's cowboy toy?",
                'Woody',
                ['Buzz', 'Rex', 'Slinky'],
                'Woody is Andy’s longtime favorite toy.',
            ],
            [
                'easy',
                "What is Buzz Lightyear's catchphrase?",
                'To infinity and beyond',
                ['Reach for the sky', 'Yeehaw', 'Play nice'],
                'Buzz repeats his Space Ranger motto.',
            ],
            [
                'easy',
                "Who is Andy's toy-destroying neighbor?",
                'Sid',
                ['Al', 'Molly', 'Scud'],
                'Sid destroys and modifies toys.',
            ],
            [
                'easy',
                'What kind of toy is Rex?',
                'A dinosaur',
                ['A dog', 'A robot', 'A dragon'],
                'Rex is a nervous green Tyrannosaurus toy.',
            ],
            [
                'medium',
                'What restaurant does Andy visit?',
                'Pizza Planet',
                ['Burger Galaxy', 'Space Slice', 'Arcade Planet'],
                'Pizza Planet is a space-themed restaurant and arcade.',
            ],
            [
                'medium',
                'What does Buzz initially believe about himself?',
                'That he is a real Space Ranger',
                [
                    'That he belongs to Sid',
                    'That he can read minds',
                    'That he is Andy’s oldest toy',
                ],
                'Buzz initially does not understand that he is a toy.',
            ],
            [
                'medium',
                'What body part comes off Buzz after he tries to fly?',
                'His arm',
                ['His leg', 'His helmet', 'His wing'],
                'Buzz loses an arm after falling from the staircase.',
            ],
            [
                'medium',
                'What type of toy is Hamm?',
                'A piggy bank',
                ['A rubber pig', 'A board-game piece', 'A plush toy'],
                'Hamm is a sarcastic piggy bank.',
            ],
            [
                'hard',
                'What is the name of Sid’s dog?',
                'Scud',
                ['Buster', 'Slinky', 'Spike'],
                'Scud aggressively chases Woody and Buzz.',
            ],
            [
                'hard',
                'How do Woody and Buzz reach Andy’s moving van?',
                'Using a rocket',
                ['Using RC alone', 'Using a kite', 'Using a balloon'],
                'They ignite Sid’s rocket and fly toward the van.',
            ],
        ],
    }),

    getOut: createMovie({
        title: 'Get Out',
        year: '2017',
        accent: '#64748b',
        posterEmoji: '☕',
        questions: [
            [
                'easy',
                'Who directed Get Out?',
                'Jordan Peele',
                ['Spike Lee', 'Ari Aster', 'Ryan Coogler'],
                'Jordan Peele wrote and directed the film.',
            ],
            [
                'easy',
                "What is Chris's profession?",
                'Photographer',
                ['Chef', 'Teacher', 'Doctor'],
                'Chris works as a photographer.',
            ],
            [
                'easy',
                "What is Chris's girlfriend's name?",
                'Rose',
                ['Georgina', 'Missy', 'Allison'],
                'Rose invites Chris to meet her family.',
            ],
            [
                'easy',
                'Who is Chris’s TSA-agent friend?',
                'Rod',
                ['Andre', 'Walter', 'Jeremy'],
                'Rod investigates after becoming suspicious of the Armitages.',
            ],
            [
                'medium',
                'What object is used to hypnotize Chris?',
                'A teacup',
                ['A watch', 'A candle', 'A phone'],
                'Missy stirs tea in a cup to trigger the hypnosis.',
            ],
            [
                'medium',
                'Where does Chris’s consciousness become trapped?',
                'The Sunken Place',
                ['The Quiet Room', 'The Void', 'The Basement'],
                'The Sunken Place represents Chris’s loss of bodily control.',
            ],
            [
                'medium',
                'What temporarily snaps Logan out of his altered state?',
                'A camera flash',
                ['A loud alarm', 'A slap', 'A glass breaking'],
                'The camera flash briefly allows the original consciousness to emerge.',
            ],
            [
                'medium',
                'What warning does Logan shout at Chris?',
                'Get out',
                ['Wake up', 'Run home', 'Call the police'],
                'Logan urgently tells Chris to escape.',
            ],
            [
                'hard',
                'What does Chris use to block the hypnosis?',
                'Cotton from the chair',
                ['Earplugs', 'Wax', 'A broken teacup'],
                'Chris pulls cotton from the chair and places it in his ears.',
            ],
            [
                'hard',
                'What is the family’s brain-transplant process called?',
                'The Coagula procedure',
                ['The Armitage method', 'The Sunken process', 'The Rebirth procedure'],
                'The Armitages refer to the operation as the Coagula procedure.',
            ],
        ],
    }),

    theOffice: createMovie({
        title: 'The Office',
        year: '2005',
        accent: '#38bdf8',
        posterEmoji: '📎',
        questions: [
            [
                'easy',
                'Who is the regional manager at the beginning?',
                'Michael Scott',
                ['Jim Halpert', 'Dwight Schrute', 'David Wallace'],
                'Michael manages the Scranton branch.',
            ],
            [
                'easy',
                'What company do the characters work for?',
                'Dunder Mifflin',
                ['Wernham Hogg', 'Sabre', 'Vance Paper'],
                'Dunder Mifflin is a paper company.',
            ],
            [
                'easy',
                'Who is the receptionist at the beginning?',
                'Pam Beesly',
                ['Angela Martin', 'Kelly Kapoor', 'Phyllis Vance'],
                'Pam works at reception before pursuing art and sales.',
            ],
            [
                'easy',
                'What food does Kevin famously spill?',
                'Chili',
                ['Soup', 'Spaghetti', 'Mashed potatoes'],
                'Kevin spills his homemade chili across the office floor.',
            ],
            [
                'medium',
                "What is Dwight's farm called?",
                'Schrute Farms',
                ['Beet Lodge', 'Mose Acres', 'Scranton Farms'],
                'Dwight runs Schrute Farms with Mose.',
            ],
            [
                'medium',
                'What item does Jim put inside Jell-O?',
                "Dwight's stapler",
                ["Michael's mug", "Pam's phone", "Creed's keys"],
                'The stapler prank appears in the first episode.',
            ],
            [
                'medium',
                'Who starts the chaotic fire drill?',
                'Dwight',
                ['Michael', 'Creed', 'Andy'],
                'Dwight stages a fake fire to test office preparedness.',
            ],
            [
                'medium',
                'Who says, “Bears. Beets. Battlestar Galactica”?',
                'Jim',
                ['Dwight', 'Michael', 'Andy'],
                'Jim says it while impersonating Dwight.',
            ],
            [
                'hard',
                "What is Michael's homemade action movie called?",
                'Threat Level Midnight',
                ['Agent Michael', 'Goldenface', 'The Scranton Spy'],
                'Michael spends years creating Threat Level Midnight.',
            ],
            [
                'hard',
                'What is the name of the office award ceremony?',
                'The Dundies',
                ['The Scranties', 'The Paper Awards', 'The Muffies'],
                'Michael hosts the annual Dundies.',
            ],
        ],
    }),

    theBear: createMovie({
        title: 'The Bear',
        year: '2022',
        accent: '#fb923c',
        posterEmoji: '🍝',
        questions: [
            [
                'easy',
                "What is Carmy's profession?",
                'Chef',
                ['Bartender', 'Critic', 'Accountant'],
                'Carmy is an award-winning chef.',
            ],
            [
                'easy',
                'What city is the show set in?',
                'Chicago',
                ['New York', 'Boston', 'Philadelphia'],
                'The restaurant is located in Chicago.',
            ],
            [
                'easy',
                "What is Carmy's full first name?",
                'Carmen',
                ['Cameron', 'Carl', 'Christopher'],
                'His full name is Carmen Berzatto.',
            ],
            [
                'easy',
                'Who owned the restaurant before Carmy?',
                'Mikey',
                ['Richie', 'Jimmy', 'Pete'],
                'Carmy inherits the restaurant after Mikey’s death.',
            ],
            [
                'medium',
                'Who is the ambitious young chef Carmy hires?',
                'Sydney',
                ['Natalie', 'Tina', 'Claire'],
                'Sydney joins the kitchen and pushes it toward excellence.',
            ],
            [
                'medium',
                'What was the restaurant originally called?',
                'The Original Beef of Chicagoland',
                ['The Bear', 'Beef Palace', 'Carmy’s'],
                'The family sandwich shop begins as The Original Beef of Chicagoland.',
            ],
            [
                'medium',
                'What does the restaurant eventually become?',
                'The Bear',
                ['The Original', 'Berzatto’s', 'Chicago Beef'],
                'The team transforms the sandwich shop into The Bear.',
            ],
            [
                'medium',
                'Why do kitchen workers shout “Corner”?',
                'To avoid collisions',
                [
                    'To announce an order',
                    'To begin service',
                    'To request assistance',
                ],
                'Kitchen workers call corners to move safely through blind spaces.',
            ],
            [
                'hard',
                'What type of food is the original restaurant known for?',
                'Italian beef sandwiches',
                ['Deep-dish pizza', 'Hot dogs', 'Pasta'],
                'The Original Beef is known for Chicago-style Italian beef.',
            ],
            [
                'hard',
                'What does Carmy discover hidden in tomato cans?',
                'Cash',
                ['Recipes', 'Drugs', 'Jewelry'],
                'Mikey hid borrowed money inside sealed tomato cans.',
            ],
        ],
    }),

    avengers: createMovie({
        title: 'The Avengers',
        year: '2012',
        accent: '#3b82f6',
        posterEmoji: '🛡️',
        questions: [
            [
                'easy',
                'Who leads the invasion of New York?',
                'Loki',
                ['Thanos', 'Ultron', 'Red Skull'],
                'Loki brings the Chitauri army to Earth.',
            ],
            [
                'easy',
                'What object contains the Space Stone?',
                'The Tesseract',
                ['The Scepter', 'The Aether', 'The Orb'],
                'The Tesseract contains the Space Stone.',
            ],
            [
                'easy',
                'Which hero uses a bow and arrow?',
                'Hawkeye',
                ['Captain America', 'Thor', 'Iron Man'],
                'Hawkeye is the team’s expert archer.',
            ],
            [
                'easy',
                'Who says, “We have a Hulk”?',
                'Tony Stark',
                ['Nick Fury', 'Thor', 'Steve Rogers'],
                'Tony uses the line while confronting Loki.',
            ],
            [
                'medium',
                'Where is S.H.I.E.L.D.’s flying headquarters located?',
                'On the Helicarrier',
                ['At Avengers Tower', 'In Wakanda', 'Under the Pentagon'],
                'Much of the team’s early conflict happens aboard the Helicarrier.',
            ],
            [
                'medium',
                'Who is being controlled by Loki?',
                'Hawkeye',
                ['Captain America', 'Bruce Banner', 'Pepper Potts'],
                'Loki controls Hawkeye with the Mind Stone-powered scepter.',
            ],
            [
                'medium',
                'Who closes the portal above New York?',
                'Black Widow',
                ['Iron Man', 'Thor', 'Hawkeye'],
                'Black Widow uses Loki’s scepter to shut the portal.',
            ],
            [
                'hard',
                'What food does the team eat after the battle?',
                'Shawarma',
                ['Pizza', 'Tacos', 'Cheeseburgers'],
                'The Avengers silently eat shawarma during the post-credits scene.',
            ],
            [
                'hard',
                'Who sacrifices himself aboard the Helicarrier?',
                'Phil Coulson',
                ['Nick Fury', 'Maria Hill', 'Erik Selvig'],
                'Loki mortally wounds Agent Coulson.',
            ],
            [
                'hard',
                'What missile does Iron Man redirect through the portal?',
                'A nuclear missile',
                ['A Chitauri missile', 'A Stark missile', 'A sonic missile'],
                'Iron Man carries a nuclear missile into the Chitauri portal.',
            ],
        ],
    }),

    avengersEndgame: createMovie({
        title: 'Avengers: Endgame',
        year: '2019',
        accent: '#8b5cf6',
        posterEmoji: '🫰',
        questions: [
            [
                'easy',
                'Who says “Avengers, assemble”?',
                'Captain America',
                ['Iron Man', 'Thor', 'Hulk'],
                'Captain America delivers the command before the final battle.',
            ],
            [
                'easy',
                'Who performs the final snap against Thanos?',
                'Iron Man',
                ['Hulk', 'Thor', 'Captain Marvel'],
                'Tony Stark uses the Stones to erase Thanos and his army.',
            ],
            [
                'easy',
                'Who is able to lift Mjolnir during the final battle?',
                'Captain America',
                ['Iron Man', 'Hawkeye', 'Spider-Man'],
                'Steve Rogers proves worthy of wielding Thor’s hammer.',
            ],
            [
                'easy',
                'How many years pass after the original Snap?',
                'Five',
                ['Three', 'Seven', 'Ten'],
                'The film jumps five years into the future.',
            ],
            [
                'medium',
                'Who retrieves the Soul Stone with Hawkeye?',
                'Black Widow',
                ['Nebula', 'Captain Marvel', 'Scarlet Witch'],
                'Natasha and Clint travel to Vormir.',
            ],
            [
                'medium',
                'What allows the Avengers to travel through time?',
                'The Quantum Realm',
                ['The Tesseract', 'The Time Stone', 'The Dark Dimension'],
                'The Avengers use the Quantum Realm for their time heist.',
            ],
            [
                'medium',
                'Who performs the snap that restores the vanished population?',
                'Hulk',
                ['Iron Man', 'Thor', 'Captain America'],
                'Hulk uses the rebuilt gauntlet to reverse the Snap.',
            ],
            [
                'medium',
                'Where do Tony and Steve travel after losing the Tesseract?',
                'Camp Lehigh in 1970',
                ['New York in 2012', 'Asgard in 2013', 'Wakanda in 2018'],
                'They travel to Camp Lehigh to retrieve more Pym Particles and the Tesseract.',
            ],
            [
                'hard',
                'What does Captain America return after the battle?',
                'The Infinity Stones and Mjolnir',
                [
                    'Only the Infinity Stones',
                    'The gauntlet',
                    'The Quantum suits',
                ],
                'Steve returns the Stones and Mjolnir to their proper timelines.',
            ],
            [
                'hard',
                'Who becomes the new Captain America at the end?',
                'Sam Wilson',
                ['Bucky Barnes', 'Peter Parker', 'Clint Barton'],
                'An elderly Steve gives his shield to Sam.',
            ],
        ],
    }),

    barbie: createMovie({
        title: 'Barbie',
        year: '2023',
        accent: '#ec4899',
        posterEmoji: '🩷',
        questions: [
            [
                'easy',
                'Who plays Barbie?',
                'Margot Robbie',
                ['Emma Stone', 'Florence Pugh', 'Sydney Sweeney'],
                'Margot Robbie plays the central Barbie.',
            ],
            [
                'easy',
                'Who plays Ken?',
                'Ryan Gosling',
                ['Chris Evans', 'Ryan Reynolds', 'Zac Efron'],
                'Ryan Gosling plays Ken.',
            ],
            [
                'easy',
                'What is Barbie’s home world called?',
                'Barbie Land',
                ['Dream Land', 'Doll World', 'Perfect Land'],
                'Barbie and the other dolls live in Barbie Land.',
            ],
            [
                'easy',
                'What suddenly becomes flat?',
                "Barbie's feet",
                ['Her car', 'Her house', 'Her hair'],
                'Barbie’s permanently arched feet unexpectedly become flat.',
            ],
            [
                'medium',
                'Where does Barbie travel to find answers?',
                'The real world',
                ['The Dreamhouse factory', 'Ken Land', 'Mattel Land'],
                'Barbie travels to Los Angeles in the real world.',
            ],
            [
                'medium',
                'What concept does Ken bring back to Barbie Land?',
                'Patriarchy',
                ['Capitalism', 'Democracy', 'Social media'],
                'Ken reshapes Barbie Land after learning about patriarchy.',
            ],
            [
                'medium',
                'What song does Ken perform?',
                "I'm Just Ken",
                ['Dance the Night', 'What Was I Made For?', 'Pink'],
                'Ken performs the musical number “I’m Just Ken.”',
            ],
            [
                'medium',
                'Who gives the speech about the contradictions women face?',
                'Gloria',
                ['Ruth', 'Sasha', 'Weird Barbie'],
                'Gloria’s speech helps awaken the Barbies.',
            ],
            [
                'hard',
                'Who sends Barbie toward the real world?',
                'Weird Barbie',
                ['President Barbie', 'Gloria', 'Ruth Handler'],
                'Weird Barbie tells her how to begin repairing the connection.',
            ],
            [
                'hard',
                'What name does Barbie choose for herself?',
                'Barbara Handler',
                ['Barbie Roberts', 'Ruth Barbie', 'Barbara Mattel'],
                'Barbie chooses humanity and introduces herself as Barbara Handler.',
            ],
        ],
    }),

    shrek: createMovie({
        title: 'Shrek',
        year: '2001',
        accent: '#84cc16',
        posterEmoji: '🧅',
        questions: [
            [
                'easy',
                'What kind of creature is Shrek?',
                'An ogre',
                ['A troll', 'A goblin', 'A giant'],
                'Shrek is an ogre who lives in a swamp.',
            ],
            [
                'easy',
                'Who becomes Shrek’s traveling companion?',
                'Donkey',
                ['Puss in Boots', 'Dragon', 'Gingy'],
                'Donkey accompanies Shrek to rescue Fiona.',
            ],
            [
                'easy',
                'Where does Shrek live?',
                'A swamp',
                ['A castle', 'A forest cottage', 'A cave'],
                'Shrek values the privacy of his swamp.',
            ],
            [
                'easy',
                'Which princess does Shrek rescue?',
                'Fiona',
                ['Aurora', 'Cinderella', 'Rapunzel'],
                'Shrek rescues Princess Fiona from the tower.',
            ],
            [
                'medium',
                'Who orders Shrek to rescue Fiona?',
                'Lord Farquaad',
                ['King Harold', 'Prince Charming', 'The Magic Mirror'],
                'Farquaad agrees to clear the swamp if Shrek rescues Fiona.',
            ],
            [
                'medium',
                'What guards Fiona’s castle?',
                'A dragon',
                ['A giant', 'A witch', 'A three-headed dog'],
                'A fire-breathing dragon guards the tower.',
            ],
            [
                'medium',
                'What does Shrek compare ogres to?',
                'Onions',
                ['Cakes', 'Books', 'Forests'],
                'Shrek explains that ogres have layers like onions.',
            ],
            [
                'medium',
                'What happens to Fiona at sunset?',
                'She becomes an ogre',
                ['She falls asleep', 'She becomes invisible', 'She loses her voice'],
                'Fiona’s curse transforms her into an ogre each night.',
            ],
            [
                'hard',
                'What song plays during the opening sequence?',
                'All Star',
                ['Holding Out for a Hero', 'Hallelujah', 'Accidentally in Love'],
                'Smash Mouth’s “All Star” plays as Shrek begins his day.',
            ],
            [
                'hard',
                'Who eats Lord Farquaad?',
                'Dragon',
                ['Shrek', 'Donkey', 'Fiona'],
                'Dragon crashes the wedding and eats Farquaad.',
            ],
        ],
    }),

    harryPotter: createMovie({
        title: "Harry Potter and the Sorcerer's Stone",
        year: '2001',
        accent: '#fbbf24',
        posterEmoji: '⚡',
        questions: [
            [
                'easy',
                'Which house is Harry sorted into?',
                'Gryffindor',
                ['Slytherin', 'Ravenclaw', 'Hufflepuff'],
                'The Sorting Hat places Harry in Gryffindor.',
            ],
            [
                'easy',
                'What is the name of Harry’s owl?',
                'Hedwig',
                ['Crookshanks', 'Scabbers', 'Errol'],
                'Hagrid buys Hedwig for Harry.',
            ],
            [
                'easy',
                'Who are Harry’s two closest friends?',
                'Ron and Hermione',
                ['Draco and Neville', 'Fred and George', 'Dean and Seamus'],
                'Ron Weasley and Hermione Granger become Harry’s closest friends.',
            ],
            [
                'easy',
                'What position does Harry play in Quidditch?',
                'Seeker',
                ['Keeper', 'Chaser', 'Beater'],
                'Harry becomes Gryffindor’s Seeker.',
            ],
            [
                'medium',
                'What platform does the Hogwarts Express leave from?',
                'Platform 9¾',
                ['Platform 7½', 'Platform 10', 'Platform 13'],
                'Students enter Platform 9¾ through a barrier.',
            ],
            [
                'medium',
                'What protects the trapdoor beneath Hogwarts?',
                'Fluffy',
                ['Aragog', 'Norbert', 'The Basilisk'],
                'Fluffy is Hagrid’s three-headed dog.',
            ],
            [
                'medium',
                'What magical object shows a person’s deepest desire?',
                'The Mirror of Erised',
                ['The Pensieve', 'The Sorting Hat', 'The Marauder’s Map'],
                'The Mirror of Erised reveals the viewer’s deepest desire.',
            ],
            [
                'medium',
                'Who teaches Potions?',
                'Severus Snape',
                ['Minerva McGonagall', 'Filius Flitwick', 'Quirinus Quirrell'],
                'Professor Snape teaches Potions.',
            ],
            [
                'hard',
                'Whose body is Voldemort sharing?',
                'Professor Quirrell',
                ['Professor Snape', 'Lucius Malfoy', 'Filch'],
                'Voldemort lives parasitically on the back of Quirrell’s head.',
            ],
            [
                'hard',
                'How does Harry obtain the Sorcerer’s Stone?',
                'It appears in his pocket',
                [
                    'He takes it from Quirrell',
                    'Dumbledore gives it to him',
                    'He finds it inside the mirror',
                ],
                'The Mirror of Erised places the Stone in Harry’s pocket.',
            ],
        ],
    }),

    hungerGames: createMovie({
        title: 'The Hunger Games',
        year: '2012',
        accent: '#f97316',
        posterEmoji: '🏹',
        questions: [
            [
                'easy',
                'Who volunteers in place of Prim?',
                'Katniss Everdeen',
                ['Rue', 'Johanna Mason', 'Effie Trinket'],
                'Katniss volunteers to protect her younger sister.',
            ],
            [
                'easy',
                'Which district is Katniss from?',
                'District 12',
                ['District 1', 'District 4', 'District 13'],
                'Katniss lives in the coal-mining District 12.',
            ],
            [
                'easy',
                'Who is the male tribute from District 12?',
                'Peeta Mellark',
                ['Gale Hawthorne', 'Finnick Odair', 'Cato'],
                'Peeta is selected alongside Katniss.',
            ],
            [
                'easy',
                'What weapon does Katniss specialize in?',
                'Bow and arrow',
                ['Sword', 'Spear', 'Throwing knives'],
                'Katniss is an expert archer.',
            ],
            [
                'medium',
                'What symbol does Katniss wear?',
                'A mockingjay pin',
                ['A silver arrow', 'A coal pendant', 'A flame necklace'],
                'The mockingjay pin becomes a symbol of resistance.',
            ],
            [
                'medium',
                'Who mentors Katniss and Peeta?',
                'Haymitch Abernathy',
                ['Caesar Flickerman', 'Cinna', 'Seneca Crane'],
                'Haymitch is District 12’s surviving victor and mentor.',
            ],
            [
                'medium',
                'What nickname does Katniss receive?',
                'The Girl on Fire',
                ['The Mockingjay Queen', 'The Archer', 'The Burning Tribute'],
                'Cinna’s costume earns Katniss the name “The Girl on Fire.”',
            ],
            [
                'medium',
                'What poisonous berries do Katniss and Peeta threaten to eat?',
                'Nightlock',
                ['Hemlock', 'Foxglove', 'Belladonna'],
                'Their nightlock threat forces the Capitol to declare two winners.',
            ],
            [
                'hard',
                'What score does Katniss receive from the Gamemakers?',
                '11',
                ['8', '10', '12'],
                'Katniss receives an unusually high score of 11.',
            ],
            [
                'hard',
                'What does Katniss shoot during her private evaluation?',
                'An apple',
                ['A light fixture', 'A glass', 'A target above the judges'],
                'She fires an arrow through the apple in the roasted pig’s mouth.',
            ],
        ],
    }),

    darkKnightRises: createMovie({
        title: 'The Dark Knight Rises',
        year: '2012',
        accent: '#475569',
        posterEmoji: '🦇',
        questions: [
            [
                'easy',
                'Who is the main masked villain?',
                'Bane',
                ['Joker', 'Scarecrow', 'Deathstroke'],
                'Bane comes to Gotham with the League of Shadows.',
            ],
            [
                'easy',
                'Who plays Selina Kyle?',
                'Anne Hathaway',
                ['Michelle Pfeiffer', 'Zoë Kravitz', 'Marion Cotillard'],
                'Anne Hathaway plays Selina Kyle.',
            ],
            [
                'easy',
                'How long has Bruce Wayne been retired as Batman?',
                'Eight years',
                ['Two years', 'Five years', 'Ten years'],
                'Batman disappeared after taking responsibility for Harvey Dent’s crimes.',
            ],
            [
                'easy',
                'What flying vehicle does Batman use?',
                'The Bat',
                ['The Batwing', 'The Tumbler', 'The Knight'],
                'Lucius introduces Bruce to an aerial vehicle called the Bat.',
            ],
            [
                'medium',
                'Where is Bruce imprisoned?',
                'An underground prison pit',
                ['Arkham Asylum', 'Blackgate Prison', 'A bunker beneath Gotham'],
                'Bane sends Bruce to the same pit where he was once imprisoned.',
            ],
            [
                'medium',
                'What does Bruce need to do to escape the pit?',
                'Make the climb without the rope',
                [
                    'Defeat every prisoner',
                    'Find a hidden tunnel',
                    'Repair his back completely',
                ],
                'Bruce escapes only after abandoning the safety rope.',
            ],
            [
                'medium',
                'Who is revealed to be Talia al Ghul?',
                'Miranda Tate',
                ['Selina Kyle', 'Jen', 'Holly Robinson'],
                'Miranda reveals herself as Ra’s al Ghul’s daughter.',
            ],
            [
                'medium',
                'What does Bane turn into a nuclear bomb?',
                'A fusion reactor',
                ['The Bat-Signal', 'Wayne Tower', 'A military satellite'],
                'Bane converts Wayne Enterprises’ reactor into a bomb.',
            ],
            [
                'hard',
                'What is John Blake’s legal first name?',
                'Robin',
                ['Richard', 'Jason', 'Tim'],
                'The final scene reveals that Blake’s legal first name is Robin.',
            ],
            [
                'hard',
                'Where is Bruce seen alive at the end?',
                'A café in Florence',
                ['Wayne Manor', 'Paris', 'Monaco'],
                'Alfred sees Bruce and Selina at a café in Florence.',
            ],
        ],
    }),

    oppenheimer: createMovie({
        title: 'Oppenheimer',
        year: '2023',
        accent: '#f97316',
        posterEmoji: '⚛️',
        questions: [
            [
                'easy',
                'Who directed Oppenheimer?',
                'Christopher Nolan',
                ['Steven Spielberg', 'Denis Villeneuve', 'David Fincher'],
                'Christopher Nolan wrote and directed the film.',
            ],
            [
                'easy',
                'Who plays J. Robert Oppenheimer?',
                'Cillian Murphy',
                ['Matt Damon', 'Robert Downey Jr.', 'Rami Malek'],
                'Cillian Murphy plays Oppenheimer.',
            ],
            [
                'easy',
                'What major project does Oppenheimer lead?',
                'The Manhattan Project',
                ['The Apollo Program', 'Project Mercury', 'The Trinity Initiative'],
                'Oppenheimer leads the Los Alamos laboratory under the Manhattan Project.',
            ],
            [
                'easy',
                'What is the first nuclear test called?',
                'Trinity',
                ['Genesis', 'Prometheus', 'Manhattan'],
                'The Trinity test takes place in New Mexico.',
            ],
            [
                'medium',
                'Where is the secret laboratory established?',
                'Los Alamos',
                ['Oak Ridge', 'Chicago', 'Princeton'],
                'The weapons laboratory is built at Los Alamos.',
            ],
            [
                'medium',
                'Who plays General Leslie Groves?',
                'Matt Damon',
                ['Josh Hartnett', 'Casey Affleck', 'Kenneth Branagh'],
                'Matt Damon plays the military director of the Manhattan Project.',
            ],
            [
                'medium',
                'Who is Oppenheimer’s wife?',
                'Kitty',
                ['Jean', 'Ruth', 'Florence'],
                'Katherine “Kitty” Oppenheimer is played by Emily Blunt.',
            ],
            [
                'medium',
                'Who drives the effort against Oppenheimer’s confirmation late in the film?',
                'Lewis Strauss',
                ['Leslie Groves', 'Edward Teller', 'Niels Bohr'],
                'The film reveals Strauss’s role in the campaign against Oppenheimer.',
            ],
            [
                'hard',
                'What type of hearing threatens Oppenheimer’s career?',
                'A security-clearance hearing',
                [
                    'A criminal trial',
                    'A military court-martial',
                    'A Senate impeachment hearing',
                ],
                'Oppenheimer’s security clearance is examined and ultimately revoked.',
            ],
            [
                'hard',
                'What fear does Oppenheimer share with Einstein at the end?',
                'They may have started a chain reaction that destroys the world',
                [
                    'Germany built the bomb first',
                    'Los Alamos would be exposed',
                    'The Trinity test failed',
                ],
                'The final scene reframes their earlier conversation around global nuclear destruction.',
            ],
        ],
    }),

    theBatman: createMovie({
        title: 'The Batman',
        year: '2022',
        accent: '#dc2626',
        posterEmoji: '🔴',
        questions: [
            [
                'easy',
                'Who plays Batman?',
                'Robert Pattinson',
                ['Christian Bale', 'Ben Affleck', 'Michael Keaton'],
                'Robert Pattinson plays Bruce Wayne and Batman.',
            ],
            [
                'easy',
                'Who is the main serial-killer villain?',
                'The Riddler',
                ['The Joker', 'Two-Face', 'Scarecrow'],
                'The Riddler targets corrupt Gotham officials.',
            ],
            [
                'easy',
                'Who plays Selina Kyle?',
                'Zoë Kravitz',
                ['Anne Hathaway', 'Michelle Pfeiffer', 'Margot Robbie'],
                'Zoë Kravitz plays Selina Kyle.',
            ],
            [
                'easy',
                'What phrase does Batman use when he emerges from the shadows?',
                'I am vengeance',
                ['I am the night', 'Fear me', 'Justice has arrived'],
                'Batman identifies himself as vengeance.',
            ],
            [
                'medium',
                'Who is Batman’s primary police ally?',
                'James Gordon',
                ['Harvey Bullock', 'Gil Colson', 'Pete Savage'],
                'Lieutenant James Gordon works closely with Batman.',
            ],
            [
                'medium',
                'What nightclub does the Penguin operate?',
                'The Iceberg Lounge',
                ['The Black Mask', 'Club Gotham', 'The Monarch'],
                'The Penguin operates the Iceberg Lounge.',
            ],
            [
                'medium',
                'What does the Riddler leave at his crime scenes?',
                'Greeting cards and riddles',
                ['Joker cards', 'Coins', 'Chess pieces'],
                'The Riddler leaves messages specifically addressed to Batman.',
            ],
            [
                'medium',
                'What nickname is given to Carmine Falcone?',
                'The Roman',
                ['The Penguin', 'The King', 'The Don'],
                'Falcone is a dominant Gotham crime boss known as the Roman.',
            ],
            [
                'hard',
                'What causes Gotham to flood?',
                'Explosives destroy the seawall',
                [
                    'A hurricane',
                    'The Batmobile crashes into a dam',
                    'A power-plant failure',
                ],
                'The Riddler’s followers detonate explosives along Gotham’s seawall.',
            ],
            [
                'hard',
                'What message does Batman learn by the end?',
                'He must become a symbol of hope',
                [
                    'Gotham cannot be saved',
                    'He must reveal his identity',
                    'Fear is enough to stop crime',
                ],
                'Bruce realizes vengeance alone cannot inspire Gotham.',
            ],
        ],
    }),

    sinners: createMovie({
        title: 'Sinners',
        year: '2025',
        accent: '#991b1b',
        posterEmoji: '🎸',
        questions: [
            [
                'easy',
                'Who directed Sinners?',
                'Ryan Coogler',
                ['Jordan Peele', 'Barry Jenkins', 'Steve McQueen'],
                'Ryan Coogler wrote and directed the film.',
            ],
            [
                'easy',
                'Who plays the twin brothers Smoke and Stack?',
                'Michael B. Jordan',
                ['Jonathan Majors', 'John Boyega', 'Daniel Kaluuya'],
                'Michael B. Jordan performs both twin roles.',
            ],
            [
                'easy',
                'What kind of establishment do Smoke and Stack open?',
                'A juke joint',
                ['A hotel', 'A record store', 'A church'],
                'The brothers return home to open a juke joint.',
            ],
            [
                'easy',
                'What supernatural creatures threaten the group?',
                'Vampires',
                ['Werewolves', 'Demons', 'Ghosts'],
                'The celebration is attacked by vampires.',
            ],
            [
                'medium',
                'In which state is the film primarily set?',
                'Mississippi',
                ['Louisiana', 'Georgia', 'Alabama'],
                'The story unfolds in the Mississippi Delta.',
            ],
            [
                'medium',
                'What kind of music is central to the story?',
                'Blues',
                ['Jazz', 'Gospel only', 'Country'],
                'Blues music drives the film’s story and themes.',
            ],
            [
                'medium',
                'What is the young musician’s name?',
                'Sammie',
                ['Remmick', 'Bo', 'Cornbread'],
                'Sammie is the twins’ musically gifted younger cousin.',
            ],
            [
                'medium',
                'Who is the primary vampire antagonist?',
                'Remmick',
                ['Delta Slim', 'Hogwood', 'Stack'],
                'Remmick leads the vampire group.',
            ],
            [
                'hard',
                'What are the twins’ full nicknames?',
                'Smoke and Stack',
                ['Smoke and Fire', 'Stack and Slim', 'Smoke and Sammie'],
                'Elijah and Elias Moore are known as Smoke and Stack.',
            ],
            [
                'hard',
                'In what year does the main story take place?',
                '1932',
                ['1922', '1945', '1955'],
                'The main events take place in 1932.',
            ],
        ],
    }),
};

/**
 * Fisher-Yates shuffle.
 *
 * Unlike `sort(() => Math.random() - 0.5)`, this produces a properly
 * randomized ordering and does not mutate the original array.
 */
const shuffle = (items) => {
    const result = [...items];

    for (let index = result.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));

        [result[index], result[randomIndex]] = [
            result[randomIndex],
            result[index],
        ];
    }

    return result;
};

export const getRandomDemoMovie = () => {
    const movies = Object.values(demoMovies);

    if (movies.length === 0) {
        return null;
    }

    return movies[Math.floor(Math.random() * movies.length)];
};

const getUniqueQuestions = (questions) => {
    const seen = new Set();

    return questions.filter((question) => {
        const normalizedQuestion = question.question.trim().toLowerCase();

        if (seen.has(normalizedQuestion)) {
            return false;
        }

        seen.add(normalizedQuestion);
        return true;
    });
};

/**
 * Builds a demo round containing between 3 and 5 questions.
 *
 * Recommended distribution:
 * 3 questions: 1 easy, 1 medium, 1 hard
 * 4 questions: 1 easy, 2 medium, 1 hard
 * 5 questions: 2 easy, 2 medium, 1 hard
 */
export const buildDemoRound = (movie, min = 3, max = 5) => {
    if (!movie?.questions?.length) {
        return [];
    }

    const safeMin = Math.max(1, Math.min(min, movie.questions.length));
    const safeMax = Math.max(
        safeMin,
        Math.min(max, movie.questions.length)
    );

    const count =
        Math.floor(Math.random() * (safeMax - safeMin + 1)) + safeMin;

    const uniqueQuestions = getUniqueQuestions(movie.questions);

    const groups = {
        easy: shuffle(
            uniqueQuestions.filter(
                (question) => question.difficulty === 'easy'
            )
        ),
        medium: shuffle(
            uniqueQuestions.filter(
                (question) => question.difficulty === 'medium'
            )
        ),
        hard: shuffle(
            uniqueQuestions.filter(
                (question) => question.difficulty === 'hard'
            )
        ),
    };

    const targets =
        count >= 5
            ? { easy: 2, medium: 2, hard: 1 }
            : count === 4
                ? { easy: 1, medium: 2, hard: 1 }
                : { easy: 1, medium: 1, hard: 1 };

    const selected = [
        ...groups.easy.slice(0, targets.easy),
        ...groups.medium.slice(0, targets.medium),
        ...groups.hard.slice(0, targets.hard),
    ];

    const selectedQuestions = new Set(
        selected.map((question) => question.question)
    );

    // Fill any missing slots if a movie lacks enough questions
    // in one of the requested difficulty groups.
    const remaining = shuffle(
        uniqueQuestions.filter(
            (question) => !selectedQuestions.has(question.question)
        )
    );

    while (selected.length < count && remaining.length > 0) {
        selected.push(remaining.shift());
    }

    return shuffle(selected)
        .slice(0, count)
        .map((question) => ({
            ...question,
            choices: shuffle(question.choices),
        }));
};